/**
 * StickyButton Component
 * 
 * This script defines a custom HTML element `<sticky-button>` that manages the visibility 
 * and behavior of a sticky button or div. The sticky button becomes visible when the 
 * product form (e.g., "Add to Bag" form) scrolls out of view, ensuring that users always 
 * have access to the button.
 * 
 * Key Features:
 * - Uses the Intersection Observer API to detect when the product form is out of view.
 * - Dynamically toggles between desktop and mobile sticky styles based on screen width.
 * - Automatically cleans up the Intersection Observer when the component is removed 
 *   from the DOM.
 */

class StickyButton extends HTMLElement {
  constructor() {
    super();
    this.handleIntersection = this.handleIntersection.bind(this);
  }

  connectedCallback() {
    this.desktopDiv = this.querySelector('.sticky-button');
    this.addToCartButton = document.querySelector('.product-form__submit');
    this.announcementBar = document.querySelector('.utility-bar');
    this.header = document.querySelector('header');

    if (this.addToCartButton && this.header) {
      // Calculate combined height of header and announcement bar
      const headerHeight = this.header.offsetHeight || 0;
      const announcementBarHeight = this.announcementBar ? this.announcementBar.offsetHeight : 0;
      const totalOffset = headerHeight + announcementBarHeight;

      this.observer = new IntersectionObserver(this.handleIntersection, {
        root: null, // Use the viewport as the root
        threshold: 0, // Trigger when the buy button div is below header+announcement bar
        rootMargin: `-${totalOffset}px 0px 0px 0px` // Adjust for header and announcement bar height
      });
      this.observer.observe(this.addToCartButton);
    }
  }

  disconnectedCallback() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  handleIntersection(entries) {
    const entry = entries[0];
    const headerHeight = this.header.offsetHeight; 

    if (entry.boundingClientRect.top <= headerHeight) {
      // Buy button is out of view
      if (window.innerWidth > 768) {
        this.desktopDiv.classList.remove('sticky-button-mobile');
        this.desktopDiv.classList.add('sticky-button', 'visible');
      } 
      else {
        this.desktopDiv.classList.remove('sticky-button');
        this.desktopDiv.classList.add('sticky-button-mobile', 'visible');
      }
    }
    if(entry.isIntersecting){
      this.desktopDiv.classList.remove('visible');
    } 
  }
}

customElements.define('sticky-button', StickyButton);